import Text from "../../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorComponent = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    large: true,
    textLight: true,
    children: children
  });
};
export default ErrorComponent;